import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, NgForm, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { Roles } from 'src/app/models/common/enumModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-solicitud-master-edit-header',
  templateUrl: './solicitud-master-edit-header.component.html',
  styleUrls: ['./solicitud-master-edit-header.component.css']
})
export class SolicitudMasterEditHeaderComponent implements OnInit {
  @Input() model: ISolicitudModel;
  @Input() disabled: boolean = false;
  @Input() escontratista: boolean = false;
  @Input() esAdminSSO: boolean = false;

  // form: FormGroup;
  listaSolicitantes: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();
  notificarA = new FormControl('', [Validators.email]);

  constructor(
    // private fb: FormBuilder,
    private sedeService: SedeService,
    private contratistaService: ContratistaService,
    private tipoVisitaService: TipoVisitaService,
    private usuarioService: SeguridadUsuarioService,
  ) {

    this.model = new SolicitudModel();

  }

  ngOnInit() {
    this.cargarSedes();
  }

  cargarSedes(){
    
      let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
          filterUsuario.idRol = Roles.SOLICITANTE;
          filterUsuario.idSede = this.model.idSede;

          this.usuarioService
            .getList(filterUsuario)
            .subscribe(
              (data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
                this.listaSolicitantes = data.items;
              }
            );
  }

  private _data = new BehaviorSubject<ISolicitudModel>(new SolicitudModel());
  // change data to use getter and setter
  @Input()
  set data(value: ISolicitudModel) {
    // set the latest value for _data BehaviorSubject
    this._data.next(value);
    this.cargarSedes();
  };

  get data() {
    // get the latest value from _data BehaviorSubject
    return this._data.getValue();
    
  }



}
